// extracted by mini-css-extract-plugin
module.exports = {"navbarBrand":"styles_navbarBrand__pjWd7","formControl":"styles_formControl__2JcBh","formControlDark":"styles_formControlDark__1k1zi"};